/**
 * Home-related strings.
 */
import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Icons from '../ui/IconButton/Icons';
import FontAwesomeButton from "../ui/Buttons/FontAwesomeButton";

export default {
    d_announcements: 'Announcements',
    h_announcements: <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'nowrap'}}>
        <p>This sections shows the changes in the latest version of the product, as well as general announcements
            about Outlaw Practice.</p>
    </div>,

    d_salesFunnel: 'Sales Stages',
    h_salesFunnel: <div>
        <p>This chart shows the current distribution of your sales pipeline, by sales stage. The distribution is by
            dollars in each sales stage (rather than raw numbers of leads in each stage), to give you a better idea of
            how much work you have coming in the next 1-3 months.</p>
        <p>To see other sales-related charts, see the Leads page.</p>
        <div>
	        <FontAwesomeButton icon={Icons.SALES.reactIcon}
	                           iconColor='darkgreen'
	                           label='Sales'
	                           route='/sales'
	        />
        </div>
    </div>,

	d_campaignRoi: 'Campaign ROI',
	h_campaignRoi: <div>
		<p>This chart shows the all-time return on investment of your marketing campaigns.</p>
		<p>To view more about your campaigns, see the <FontAwesomeIcon icon={Icons.MARKETING.reactIcon} color='#cc7a00'/> Marketing
			page.</p>
		<div>
			<FontAwesomeButton icon={Icons.MARKETING.reactIcon}
			                   iconColor='#cc7a00'
			                   label='Marketing'
			                   route='/marketing/campaigns'
			/>
		</div>
	</div>,

    d_campaignFlow: 'Campaign Flow',
    h_campaignFlow: <div>
        <p>This chart shows how your marketing campaigns are performing.</p>
		<p>The first section shows how campaigns have fared in terms of bringing you clients.</p>
		<p>The second section shows how good those clients have been in terms of paying their bills.</p>
        <p>To view more about your campaigns, see the <FontAwesomeIcon icon={Icons.MARKETING.reactIcon} color='#cc7a00'/> Marketing
        page.</p>
        <div>
	        <FontAwesomeButton icon={Icons.MARKETING.reactIcon}
	                           iconColor='#cc7a00'
	                           label='Marketing'
	                           route='/marketing/campaigns'
	        />
        </div>
    </div>
};
